<template>
  <b-container>
    <b-row class="text-center pt-4">
      <b-col v-if="signInBtn">
        <b-button
          v-if="!spinner"
          class="mt-4"
          variant="success"
          @click="RedirectToLogin()"
          >{{ $t("action.login") }}</b-button
        >
      </b-col>
    </b-row>

    <b-row v-if="error" class="text-center pt-4">
      <b-col>
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </b-col>
    </b-row>

    <b-row v-if="info" class="text-center pt-4">
      <b-col>
        <b-alert show variant="info">
          <p>{{ info }}</p>
        </b-alert>
      </b-col>
    </b-row>

    <div v-if="spinner" class="text-center align-middle">
      <b-spinner
        style="width: 3rem; height: 3rem"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>
  </b-container>
</template>

<script>
import { mappBuildingDataForSelect } from '../assets/Utils.js';
import axios from "axios";
import * as msal from "@azure/msal-browser";

export default {
  props: ["redirect"],
  data: () => ({
    spinner: true,
    success: false,
    signInBtn: false,
    error: "",
    info: "",
    scope: [
      "user.read"
    ],
    tenantId: ["326c0bd4-11c9-41cc-be49-55e652fc8ea3"],
  }),
  mounted() {
    let promise = this.RedirectToLogin();
    promise.then(() => {
      console.log("Redirect to login terminated");
    });
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
    redirectUri: function() {
       
      let redirectUri = "http://localhost:8080/";
      const env = process.env.VUE_APP_WHERE;
      
      if (env === 'prod') {
        let uriFromBrowser = window.location.origin;
        if (uriFromBrowser === "https://admin-crm-multi.cogir.net") {
          redirectUri =  "https://admin-crm-multi.cogir.net";
        }
      }
      return redirectUri;
    }
  },
  methods: {
    getConfig: function () {
      const config = {
        auth: {
          clientId: "1b07e23e-1181-4ace-8936-526f8b9a4d7d",
          redirectUri: this.redirectUri,
          postLogoutRedirectUri: this.redirectUri,
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: false,
          secureCookies: false,
        },
      };

      const myMSALObj = new msal.PublicClientApplication(config);

      this.$store.commit("addmsalObj", myMSALObj);

      return myMSALObj;
    },
    RedirectToLogin: async function () {
      const myMSALObj = this.getConfig();
      return myMSALObj
        .handleRedirectPromise()
        .then((tokenResponse) => {
          let accountObj = null;
          if (tokenResponse !== null) {
            accountObj = tokenResponse.account;
            this.$store.commit("addMicrosoftAccount", accountObj);

            const token = tokenResponse.accessToken;
            this.$store.commit("addUserToken", token);

            this.getGraphUser(token);
          } else {
            let loginRequest = {
              scopes: this.scope,
            };
            const currentAccounts = myMSALObj.getAllAccounts();
            if (!currentAccounts || currentAccounts.length === 0) {
              // No user signed in
              myMSALObj.loginRedirect(loginRequest);
            } else {
              accountObj = currentAccounts.find((c) =>
                this.tenantId.includes(c.tenantId)
              );

              if (accountObj) {
                this.$store.commit("addMicrosoftAccount", accountObj);

                let accessTokenRequest = {
                  scopes: this.scope,
                  account: accountObj,
                };

                myMSALObj
                  .acquireTokenSilent(accessTokenRequest)
                  .then(function (accessTokenResponse) {
                    const token = accessTokenResponse.accessToken;
                    this.$store.commit("addUserToken", token);
                    // Call your API with token
                    this.getGraphUser(token);
                  })
                  .catch(function () {
                    console.log("Acquire token failed");
                    myMSALObj.acquireTokenRedirect(accessTokenRequest);
                  });
              } else {
                console.log("Cogir tenant not found");
                this.signInBtn = true;
                this.spinner = false;
              }
            }
          }
        })
        .catch(() => {
          //After log out
          this.signInBtn = true;
          this.spinner = false;
        });
    },
    getGraphUser(token) {
      this.spinner = true;
      let graphEndpoint = "https://graph.microsoft.com/v1.0/me";
      axios.get(graphEndpoint, { headers: {"Authorization" : `Bearer ${token}`, 'Content-Type': 'application/json'} })
      .then((response)  => {
        if (response.status === 200) {
          this.$store.commit('addGraphUser', response.data);
          let email = response.data.mail;
          this.getUserRoleAndPermission(email, token);
        }

        else {
          this.error = this.$t('info.UserNotAuthorized');
          this.spinner = false;
          this.signInBtn = true;
        }
      })
      .catch(()  => {
        this.info = this.$t('info.errorlogin');
        this.spinner = false;
        this.signInBtn = true;
      });
  },
  getUserRoleAndPermission(email, token) {
    let urls = this.$store.getters.getUrlsList;
    let url = urls[process.env.VUE_APP_WHERE].json;

    axios.post(url, {request: "getUserRoleAndPermission", email: email}, { headers: {"Authorization" : `Bearer ${token}`, 'Content-Type': 'application/json'}})
       .then((response)  => {
         let values = response.data;
         if (response.status === 200 && values.hasOwnProperty("user") && values.hasOwnProperty("buildings")) {
           this.$store.commit('addUser', values.user);
           this.$store.commit('addUserBuilding', values.buildings);
           this.getGlobalData(values);
         }

         else {
           this.error = this.$t('info.UserNotAuthorized');
           this.spinner = false;
           this.signInBtn = true;
         }
       })
       .catch(()  => {
         this.error = this.$t('info.errorgeneric');
         this.spinner = false;
         this.signInBtn = true;
       });
  },
  getGlobalData: function(values) {
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;
      
      axios.post(url, {request: "getGlobalData"}, { headers: {"Authorization" : `Basic ${values.user.email}`,'Content-Type': 'application/json'}})
         .then((response)  => {
           
           this.$store.commit('addGlobalData', response.data);
           this.dispatchUser(values);
           this.spinner = false;
         })
         .catch(()  => {
           this.error = this.$t('info.errorgeneric');           
           this.disabled = false;
         });
  },
  dispatchUser(values) {
    switch (values.user.role) {     
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        this.$emit('changePage', 'Dashboard');
        break;
      default:
        this.$emit('changePage', 'NotFound');
      break;
    }
  },
  dispatchRedirect(values, component) {
    if (component === 'DrApprobation' && values.user.role > 2) {
      this.$emit('changePage', component);
    }
    else if (component === 'prospectslist' && values.user.role !== 2) {
      let fromQuery = this.$store.getters.getBuildingFromQuery;
      let buildings = this.getBuildings();
      let building = buildings.find(b => b.value.NOCIE == fromQuery.NOCIE && b.value.NODIV == fromQuery.NODIV);
      this.$store.commit('addBuildingForProspect', building.value);
      this.$store.commit('setSearch', fromQuery.EMAIL);
      this.$emit('changePage', component);
    }
    else {
      this.dispatchUser(values);
    }
  },
  getBuildings: function () {
      let buildings = this.$store.getters.getUserBuilding;
      let res = [];
      if (buildings) {
          res = mappBuildingDataForSelect(buildings);
      }
      return res;
    },
},
components: {}
}
</script>
